import { useSelector } from 'react-redux'
import ExportModal from 'components/modals/ExportModal'
import { toggleModal } from 'store/ui/actions'

const ExportReportModal = ({
  actionCreator,
  supportedParams = ['format', 'direction']
}) => {
  const show = useSelector(({ ui }) => ui.exportReportModalShow)

  return (
    <ExportModal
      title='Export Citations'
      show={show}
      toggle={() => toggleModal('exportReport')}
      supportedParams={supportedParams}
      actionCreator={actionCreator}
    />
  )
}

export default ExportReportModal
